import { fixtureKickoff, finishedFixture } from './dayFixtureWorkflow';
import { isFixtureEvaluationFinalized } from './fixtureFinalization';

// Explicit compilation uses current settings; historical forecasts remain frozen.
export async function compileStatistics(ids, rows, post, now = Date.now()) {
  const byId = new Map(rows.map(row => [Number(row.id), row]));
  const failed = [], refreshed = [];
  for (const id of new Set(ids.map(Number))) {
    const row = byId.get(id);
    if (row?.statistic_model_applicable === false) continue;
    if (row && (finishedFixture(row) || isFixtureEvaluationFinalized(row) || fixtureKickoff(row) <= now)) continue;
    try {
      if (!row || !Number.isFinite(fixtureKickoff(row))) throw Error('FIXTURE_CONTEXT_MISSING');
      const response = await post('statistic-model', JSON.stringify({
        mode: 'predict', fixture_id: id, league_id: Number(row.league_id),
        season_id: Number(row.season_id), refresh_future: true, current_only: true, force_refresh: true,
      }));
      const data = await response.json();
      if (!response.ok || data.success !== true) throw Error(data.code || 'STATISTICS_COMPILATION_FAILED');
      if (data.reused === true) throw Error('STATISTICS_FORECAST_FROZEN');
      refreshed.push(id);
    } catch (error) { failed.push({id, error: error.message}); }
  }
  return {failed, refreshed};
}
